// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__7vJT0","title":"FrontImage_title__3qJzN"};